define([
    "dojo/_base/declare",
    "dojo/_base/lang",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginToggleButton"
], function(declare,lang,PluginFactory,ToolbarPluginToggleButton) {

	return PluginFactory.declare("slicerToggleGraphs", ToolbarPluginToggleButton, {
		constructor: function() {
			this.defAction.m_id = "SlicerToggleGraphs";
			this.defAction.m_onAction = "onActionSetValue";
			this.defAction.isToggledInitially = function(/*Context?*/ctx) {
				return ctx.view.get("showGraphs");
			};
			this.defAction.resolve();
		},

		postCreate: function() {
			var view = this.getView();
			this.inherited(arguments);
			view.watch("showGroups", lang.hitch(this, this._onWatchProperty));
		},

		onChange: function(/*Object*/value, /*Action*/action) {
			// summary: user callback for when widget is clicked (buttons)
			this.inherited(arguments, [{showGraphs: value}, action]);
		},

		_onWatchProperty: function(/*String*/name, /*Any*/oldValue, /*Any*/newValue) {
			// summary: set disabled false to make sure onChange invokeAction is called while changing views
			this.set("checked", !!newValue, false);
		}
	});
});